import * as FlatModels from '@medsurf/flat-models';

// <editor-fold desc="Action Types">

/**
 * Action Types
 */
export enum ActionTypes {
  /**
   * Store
   */
  GetDetachedPageEntitySuccess = '[STORE | CONTROL | SLIDE] Get Detached Page Entity Success',
  GetDetachedPageEntitiesSuccess = '[STORE | CONTROL | SLIDE] Get Detached Page Entities Success',
  GetPageByCurrentRoute = '[STORE | CONTROL | PAGE] Get Page By Current Route',
  GetDetachedPages = '[STORE | CONTROL | PAGE] Get Detached Pages',
  /**
   * Request
   */
  GetPageByTitleRequest = '[REQUEST | CONTROL | PAGE] Get Page By Title Request',
  GetDetachedPagesRequest = '[REQUEST | CONTROL | PAGE] Get Detached Pages Request',
}

// </editor-fold>

// <editor-fold desc="Models">

// </editor-fold>

// <editor-fold desc="Store">

/**
 * Get Detached Page Entity Success
 */
export class GetDetachedPageEntitySuccess {
  public static readonly type = ActionTypes.GetDetachedPageEntitySuccess;
  
  public constructor(public entityQueryResult: FlatModels.PageControlModels.PageControlDetachedPageQueryResult) {
  }
}

/**
 * Get Detached Page Entities Success
 */
export class GetDetachedPageEntitiesSuccess {
  public static readonly type = ActionTypes.GetDetachedPageEntitiesSuccess;
  
  public constructor(public entityQueryResults: FlatModels.PageControlModels.PageControlDetachedPageQueryResult[]) {
  }
}

/**
 * Get Page By Current Route
 */
export class GetPageByCurrentRoute {
  public static readonly type = ActionTypes.GetPageByCurrentRoute;
}

/**
 * Get Detached Pages
 */
export class GetDetachedPages {
  public static readonly type = ActionTypes.GetDetachedPages;
  
  public constructor(public search: FlatModels.SearchControlModels.NodeSearch) {
  }
}

// </editor-fold>

// <editor-fold desc="Request">

/**
 * Get Page By Title Request
 */
export class GetPageByTitleRequest {
  public static readonly type = ActionTypes.GetPageByTitleRequest;

  public constructor(public title: string) {
  }
}

/**
 * Get Detached Pages Request
 */
export class GetDetachedPagesRequest {
  public static readonly type = ActionTypes.GetDetachedPagesRequest;
  
  public constructor(public search: FlatModels.SearchControlModels.NodeSearch) {
  }
}

// </editor-fold>
